import { Observable } from 'rxjs';
import { UserRun } from '../../Models/User/UserRun';
import { UserSettings } from '../../Models/User/UserSettings';
import { Request } from '../Request/Request';
import { UserManager } from './UserManager';

export class SmoUserManager implements UserManager {
  public updateSettings(settings: UserSettings): Observable<UserSettings> {
    return new Request().withPath('/user/settings').withBody(settings).post();
  }

  public startRunWithMoonListId(moonListId: string): Observable<UserRun> {
    return new Request().withPath('user/run').withBody({ moonListId }).post();
  }

  public collectMoonWithId(moonId: string): Observable<UserRun> {
    return new Request().withPath('/user/run/collect').withBody({ moonId }).post();
  }
}
